export default __webpack_public_path__ + "static/media/fileUpload.eceabff6.svg";